import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  styled,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import OldDeletePopIcon from "../../../assets/images/delete_popup_icon.svg";
import DeletePopIcon from "assets/icons/newDeleteIcon.svg";
import ExclamationSign from "assets/icons/exclamation_Mark.svg";
import closeIcon from "assets/icons/cross_icon_link.svg";
// import closeIcon from "assets/icons/cross_icon.svg";
// import closeIcon from "assets/icons/cross.svg";
import CustomButton from "../Button";

function Edit(props) {
  const [show, setShow] = useState(false);
  const {
    open,
    onClose,
    alertMessage,
    onEditForm,
    editButtonText,
    cancelButtonText,
    enableDangerousHTML,
    removeDefaultHeading,
    alertTitle,
    newEditform,
    type,
  } = props;

  // Show or hide the modal.
  useEffect(() => {
    setShow(open);
  }, [open]);

  return !newEditform ? (
    <Dialog open={show} onClose={onClose} classes={{ paper: "delete-modal" }}>
      <DialogTitle className="text-center">
        <img
          src={OldDeletePopIcon}
          alt="Delete-popup image"
          className="delete-popup-icon"
        />
      </DialogTitle>
      <DialogContent className="text-center delete-dialog-content">
        <h3>Are you sure?</h3>
        {enableDangerousHTML ? (
          <span dangerouslySetInnerHTML={{ __html: alertMessage }} />
        ) : (
          <span>{alertMessage}</span>
        )}
        <Grid container>
          <Grid item lg={12} md={12} sm={12} className="text-center mt-4">
            <CustomButton
              type="button"
              btnProps={{
                text: cancelButtonText || "Cancel",
                className: "cancel-btn mr-5",
                variant: "contained",
                onClick: onClose,
              }}
            />
            <CustomButton
              type="button"
              btnProps={{
                text: editButtonText || "Yes, Edit it!",
                className: "cancel-btn delete-btn",
                variant: "contained",
                onClick: onEditForm,
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  ) : (
    <Dialog
      open={show}
      onClose={onClose}
      classes={{ paper: "new-delete-modal" }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          margin: "0.5rem 1rem 1.5rem 1rem",
          color: "#F56232",
        }}
      >
        <span
          style={{
            fontSize: "1rem",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            flexDirection: "row",
          }}
        >
          <span style={{ marginRight: "0.2rem" }}>
            {<img src={ExclamationSign} alt="image" />}
          </span>
          <span>{type ?? ""}</span>
        </span>
        <span>
          <img
            onClick={() => onClose()}
            src={closeIcon}
            width={20}
            style={{
              cursor: "pointer",
              filter:
                "invert(51%) sepia(49%) saturate(3703%) hue-rotate(341deg) brightness(98%) contrast(96%)",
            }}
            alt="close"
          />
        </span>
      </div>
      {type == "Cancelled ?" && (
        <DialogTitle className="text-center">
          <img
            src={DeletePopIcon}
            alt="Delete-popup image"
            width={50}
            // style={{marginTop:"1rem"}}
            // className="delete-popup-icon"
          />
        </DialogTitle>
      )}
      <DialogContent className="text-center new-delete-dialog-content">
        {!removeDefaultHeading && <h4>Are you sure?</h4>}
        {enableDangerousHTML ? (
          <span
            style={{ color: "#2a2a2a", fontSize: "23px", fontWeight: "500" }}
            dangerouslySetInnerHTML={{ __html: alertMessage }}
          />
        ) : (
          <span>{alertMessage}</span>
        )}
        <Grid container>
          <Grid
            style={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}
            item
            lg={12}
            md={12}
            sm={12}
            className="text-center mt-4"
          >
            <CustomButton
              type="button"
              btnProps={{
                text: cancelButtonText || "Cancel",
                className: "cancel-btn mr-5",
                variant: "outlined",
                onClick: onClose,
                style: {
                  borderColor: "#F56232",
                  color: "#F56232",
                  paddingInline: "2rem",
                  width: "7rem",
                },
                className: "",
              }}
            />

            <CustomButton
              type="button"
              btnProps={{
                text: editButtonText || "Yes, Edit it!",
                // className: "cancel-btn delete-btn",
                style: {
                  borderColor: "#F56232",
                  background: "#F56232",
                  color: "white",
                  paddingInline: "2rem",
                  width: "7rem",
                },
                variant: "contained",
                onClick: onEditForm,
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default withRouter(Edit);
